<template>
  <div>
    <label class="label">Forma prawna:</label>
    <w-radio :model="model" value="Stowarzyszenie Rejestrowe">Stowarzyszenie rejestrowe</w-radio>
    <w-radio :model="model" value="Stowarzyszenie Zwykłe">Stowarzyszenie zwykłe</w-radio>
    <w-radio
      :model="model"
      value="Stowarzyszenie Kultury Fizycznej"
    >Stowarzyszenie kultury fizycznej</w-radio>
    <w-radio :model="model" value="Stowarzyszenie Ogrodowe">Stowarzyszenie ogrodowe</w-radio>
    <w-radio :model="model" value="Fundacja">Fundacja</w-radio>
    <w-radio
      :model="model"
      value="Organizcja powstała na mocy umowy państwo-kościół"
    >Organizacja powstała na mocy umowy państwo-kościół</w-radio>
    <w-radio :model="model" value="Spółdzielnia socjalna">Spółdzielnia socjalna</w-radio>
    <w-radio :model="model" value="Spółka prawa handlowego">Spółka prawa handlowego</w-radio>
  </div>
</template>

<script>
import WInput from '../../components/input.vue';
import WRadio from '../../components/radio.vue';

export default {
  name: 'w-legal-form',
  components: {WInput, WRadio},
  props: {
    model: Object
  }
};
</script>

<style>
</style>
